// ------------------ UNIT STATE ------------------
const unitState = {
  height: 'in',   // 'in' | 'cm'
  weight: 'kg',   // 'kg' | 'lbs'
  waist: 'in',    // 'in' | 'cm'
  hip: 'in',      // 'in' | 'cm'
  outline: 'in'   // 'in' | 'cm'
};

// Conversion helpers (absolute units)
function inchesToCm(inches) {
  return inches * 2.54;
}
function cmToInches(cm) {
  return cm / 2.54;
}
function kgToLbs(kg) {
  return kg * 2.20462;
}
function lbsToKg(lbs) {
  return lbs / 2.20462;
}

// ------------------ CUP SIZE & OUTLINE DATA ------------------
const cupSizes = ['AA','A','B','C','D','DD','E','F','G','GG','HH'];

// Outline base list in inches – EVEN values from 28 to 54
const outlineListIn = Array.from({ length: ((54 - 28) / 2) + 1 }, (_, i) => 28 + (i * 2));

// ------------------ UNIT UI TOGGLING ------------------
function updateUnitUI(group, newUnit) {
  unitState[group] = newUnit;

  // Toggle pill state
  const groupEl = document.querySelector(`.zsr-unit-toggle[data-unit-group="${group}"]`);
  if (groupEl) {
    groupEl.querySelectorAll('.zsr-unit-toggle__btn').forEach(btn => {
      btn.classList.toggle('zsr-unit-toggle__btn--active', btn.dataset.unit === newUnit);
    });
  }

  // Re-populate corresponding dropdown list based on new unit
  if (group === 'height') {
    populateHeightList();
  } else if (group === 'weight') {
    populateWeightList();
  } else if (group === 'waist') {
    populateWaistList();
  } else if (group === 'hip') {
    populateHipList();
  } else if (group === 'outline') {
    populateOutline();
  }

  // Clear current selection when unit changes
  const boundBtn = document.querySelector(`button[data-unit-binding="${group}"]`);
  if (boundBtn) {
    boundBtn.textContent = boundBtn.getAttribute('data-placeholder') || boundBtn.textContent.replace(/[\d\s.]+(cm|CM|in|IN|kg|KG|lbs|LBS)/, '').trim();
    boundBtn.removeAttribute('data-value');
  }
}

// Delegate clicks for unit toggles
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.zsr-unit-toggle__btn');
  if (!btn) return;
  const groupEl = btn.closest('.zsr-unit-toggle');
  const group = groupEl?.dataset.unitGroup;
  const unit = btn.dataset.unit;
  if (!group || !unit) return;
  updateUnitUI(group, unit);
});

// ------------------ GENERIC LIST POPULATION ------------------
function populateList(listEl, start, end, labelFormatter){
  if(!listEl) return;
  listEl.innerHTML='';
  for(let v=start; v<=end; v++){
    const li = document.createElement('li');
    li.setAttribute('role','menuitem');
    li.tabIndex=0;
    li.dataset.value = v;
    li.textContent = labelFormatter ? labelFormatter(v) : v;
    listEl.appendChild(li);
  }
}

// ------------------ HEIGHT LIST (ABSOLUTE in/cm) ------------------
// Base range in inches for height
const HEIGHT_MIN_IN = 52;
const HEIGHT_MAX_IN = 83;

function populateHeightList() {
  const list = document.getElementById('zds-344-list');
  if (!list) return;
  const isCm = unitState.height === 'cm';
  list.innerHTML = '';

  if (!isCm) {
    // Inches with feet
    for (let v = HEIGHT_MIN_IN; v <= HEIGHT_MAX_IN; v++) {
      const li = document.createElement('li');
      li.setAttribute('role', 'menuitem');
      li.tabIndex = 0;
      li.dataset.value = v; // inches

      const feet = Math.floor(v / 12);
      const inches = v % 12;
      li.textContent = `${feet}' ${inches}" (${v} in)`;

      list.appendChild(li);
    }
  } else {
    // Centimeters (converted from inches and rounded)
    for (let v = HEIGHT_MIN_IN; v <= HEIGHT_MAX_IN; v++) {
      const cm = Math.round(inchesToCm(v));
      const li = document.createElement('li');
      li.setAttribute('role', 'menuitem');
      li.tabIndex = 0;
      li.dataset.value = cm; // cm
      li.textContent = `${cm} cm`;
      list.appendChild(li);
    }
  }
}


// ------------------ WEIGHT LIST (KG/LBS, absolute) ------------------
const WEIGHT_MIN_KG = 30;
const WEIGHT_MAX_KG = 140;

function populateWeightList() {
  const list = document.getElementById('zds-346-list');
  if (!list) return;
  const isLbs = unitState.weight === 'lbs';
  list.innerHTML = '';

  if (!isLbs) {
    // KG
    for (let v = WEIGHT_MIN_KG; v <= WEIGHT_MAX_KG; v++) {
      const li = document.createElement('li');
      li.setAttribute('role','menuitem');
      li.tabIndex=0;
      li.dataset.value = v;
      li.textContent = `${v} kg`;
      list.appendChild(li);
    }
  } else {
    // LBS based on KG range
    for (let kg = WEIGHT_MIN_KG; kg <= WEIGHT_MAX_KG; kg++) {
      const lbs = Math.round(kgToLbs(kg));
      const li = document.createElement('li');
      li.setAttribute('role','menuitem');
      li.tabIndex=0;
      li.dataset.value = lbs;
      li.textContent = `${lbs} lbs`;
      list.appendChild(li);
    }
  }
}

// ------------------ WAIST LIST (in/cm absolute) ------------------
const WAIST_MIN_IN = 20;
const WAIST_MAX_IN = 55;

function populateWaistList() {
  const list = document.getElementById('zds-430-list');
  if (!list) return;
  const isCm = unitState.waist === 'cm';
  list.innerHTML = '';

  if (!isCm) {
    for (let v = WAIST_MIN_IN; v <= WAIST_MAX_IN; v++) {
      const li = document.createElement('li');
      li.setAttribute('role','menuitem');
      li.tabIndex=0;
      li.dataset.value = v;
      li.textContent = `${v} in`;
      list.appendChild(li);
    }
  } else {
    for (let v = WAIST_MIN_IN; v <= WAIST_MAX_IN; v++) {
      const cm = Math.round(inchesToCm(v));
      const li = document.createElement('li');
      li.setAttribute('role','menuitem');
      li.tabIndex=0;
      li.dataset.value = cm;
      li.textContent = `${cm} cm`;
      list.appendChild(li);
    }
  }
}

// ------------------ HIP LIST (in/cm absolute) ------------------
const HIP_MIN_IN = 28;
const HIP_MAX_IN = 59;

function populateHipList() {
  const list = document.getElementById('zds-432-list');
  if (!list) return;
  const isCm = unitState.hip === 'cm';
  list.innerHTML = '';

  if (!isCm) {
    for (let v = HIP_MIN_IN; v <= HIP_MAX_IN; v++) {
      const li = document.createElement('li');
      li.setAttribute('role','menuitem');
      li.tabIndex=0;
      li.dataset.value = v;
      li.textContent = `${v} in`;
      list.appendChild(li);
    }
  } else {
    for (let v = HIP_MIN_IN; v <= HIP_MAX_IN; v++) {
      const cm = Math.round(inchesToCm(v));
      const li = document.createElement('li');
      li.setAttribute('role','menuitem');
      li.tabIndex=0;
      li.dataset.value = cm;
      li.textContent = `${cm} cm`;
      list.appendChild(li);
    }
  }
}

// ------------------ OUTLINE DROPDOWN (in/cm absolute) ------------------
function populateOutline() {
  const outlineListEl = document.getElementById('zds-outline-list');
  if(!outlineListEl) return;
  outlineListEl.innerHTML = '';

  const isCm = unitState.outline === 'cm';

  outlineListIn.forEach(outIn => {
    const li = document.createElement('li');
    li.setAttribute('role','menuitem');
    li.tabIndex = 0;

    if (!isCm) {
      li.dataset.value = outIn; // inches
      li.textContent = `${outIn} in`;
    } else {
      const cmVal = Math.round(inchesToCm(outIn));
      li.dataset.value = cmVal; // centimeters
      li.textContent = `${cmVal} cm`;
    }

    li.addEventListener('click', e => {
      e.preventDefault();
      const btn = document.getElementById('zds-outline');
      btn.textContent = li.textContent;
      btn.dataset.value = li.dataset.value;
      btn.focus();
      closeAllDropdowns();
    });

    outlineListEl.appendChild(li);
  });

  const outlineBtn = document.getElementById('zds-outline');
  if(outlineBtn){
    outlineBtn.textContent = 'Select Outline';
    outlineBtn.removeAttribute('data-value');
  }
}

// Initial population
populateHeightList();
populateWeightList();
populateWaistList();
populateHipList();
populateOutline();

// ------------------ CUP SIZE DROPDOWN ------------------
const cupListEl = document.getElementById('zds-cup-list');
if (cupListEl) {
  cupListEl.innerHTML = '';
  cupSizes.forEach(cup => {
    const li = document.createElement('li');
    li.setAttribute('role','menuitem');
    li.tabIndex = 0;
    li.dataset.value = cup;
    li.textContent = cup;
    li.addEventListener('click', e => {
      e.preventDefault();
      const btn = document.getElementById('zds-cup-size');
      btn.textContent = cup;
      btn.dataset.value = cup;
      btn.focus();
      populateOutline();
      closeAllDropdowns();
    });
    cupListEl.appendChild(li);
  });
}

// ------------------ DROPDOWN CONFIG FOR AGE ONLY ------------------
const dropdownsConfig = [
  { listId:'zds-348-list', start:10, end:80, fmt: v => `${v} years` } // age
];

dropdownsConfig.forEach(d => {
  const list = document.getElementById(d.listId);
  if(!list) return;
  list.innerHTML='';
  for(let v=d.start; v<=d.end; v++){
    const li = document.createElement('li');
    li.setAttribute('role','menuitem');
    li.tabIndex=0;
    li.dataset.value = v;
    li.textContent = d.fmt(v);
    list.appendChild(li);
  }
});

// ------------------ DROPDOWN LOGIC ------------------
function closeAllDropdowns(exceptList=null){
  document.querySelectorAll('.zds-drop-down-list').forEach(ul=>{
    if(ul!==exceptList){
      ul.style.display='none';
      ul.setAttribute('aria-hidden','true');
      const triggerId = ul.id.replace(/-list$/,'');
      const triggerBtn = document.getElementById(triggerId) || document.querySelector(`[data-list="${ul.id}"]`);
      if(triggerBtn) triggerBtn.setAttribute('aria-expanded','false');
    }
  });
}

document.addEventListener('click', e=>{
  const trigger = e.target.closest('.zsr-dropdown-trigger, .zsr-dropdown > .zds-button');
  if(trigger){
    const listIdCandidates = [trigger.dataset.list, `${trigger.id}-list`, trigger.id.replace(/Btn$/,'List')];
    let listEl=null;
    for(const id of listIdCandidates){
      if(!id) continue;
      listEl=document.getElementById(id);
      if(listEl) break;
    }
    if(!listEl) return;
    const isOpen = listEl.style.display==='block';
    closeAllDropdowns(listEl);
    if(!isOpen){
      listEl.style.display='block';
      listEl.setAttribute('aria-hidden','false');
      trigger.setAttribute('aria-expanded','true');
      const first=listEl.querySelector('li');
      if(first) first.focus();
    }
    e.stopPropagation();
    return;
  }

  const li = e.target.closest('.zds-drop-down-list li');
  if(li){
    const listEl = li.closest('.zds-drop-down-list');
    const triggerBtn = document.getElementById(listEl.id.replace('-list','')) || document.querySelector(`[data-list="${listEl.id}"]`);
    if(triggerBtn){
      triggerBtn.textContent=li.textContent;
      triggerBtn.dataset.value=li.dataset.value;
      triggerBtn.focus();
    }
    closeAllDropdowns();
    e.stopPropagation();
    return;
  }

  const deselect = e.target.closest('.zsr-dropdown__deselectable-button');
  if(deselect){
    const btn=document.getElementById(deselect.dataset.target);
    if(btn){
      btn.textContent=btn.getAttribute('aria-label')?.replace(/^select /i,'') || '0';
      btn.removeAttribute('data-value');
      btn.focus();
    }
    return;
  }

  if(!e.target.closest('.zsr-dropdown') && !e.target.closest('.zds-drop-down-list')){
    closeAllDropdowns();
  }
});

// ------------------ SLIDER ------------------
const fitSlider=document.getElementById('zds-slider-thumb-4340');
const fitValue=document.getElementById('fitValue');
if(fitSlider){
  const labels=['Fitted','Normal','Loose'];
  fitSlider.addEventListener('input', e=>{
    const v=parseInt(e.target.value,10);
    fitValue.textContent = labels[v] || 'Normal';
  });
}

// ------------------ DRAWER ------------------
const drawerRoot = document.getElementById('zdsDrawer');
const openBtn = document.getElementById('openZdsDrawer');
const backBtn = document.getElementById('zdsBackBtn');
const screensInner = document.getElementById('zdsScreensInner');
const headerTitle = document.getElementById('zds-337');
const subtitleEl = document.getElementById('zdsSubtitle');
let currentStep=1;
const totalSteps=4;

openBtn?.addEventListener('click',()=>{
  drawerRoot.classList.add('open');
  drawerRoot.setAttribute('aria-hidden','false');
  currentStep=1;
  updateForStep();
  setTimeout(()=>{
    const first=document.querySelector('#screen-1 .zsr-dropdown .zds-button');
    if(first) first.focus();
  },200);
});

document.addEventListener('keydown', e=>{
  if(e.key==='Escape' && drawerRoot.classList.contains('open')){
    drawerRoot.classList.remove('open');
    drawerRoot.setAttribute('aria-hidden','true');
    closeAllDropdowns();
  }
});

// ------------------ STEP NAVIGATION ------------------
function goToStep(step){
  if(step<1) step=1;
  if(step>totalSteps) step=totalSteps;
  currentStep=step;
  screensInner.style.transform = `translateX(${-(currentStep-1)*100}%)`;
  updateForStep();
}

function updateForStep(){
  document.querySelectorAll('.zds-screen').forEach(s=>{
    const step = Number(s.dataset.step);
    s.setAttribute('aria-hidden', step===currentStep ? 'false':'true');
  });

  switch(currentStep){
    case 1:
      headerTitle.textContent='Basic information';
      subtitleEl.style.display='none';
      backBtn.style.display='none';
      break;
    case 2:
      headerTitle.textContent='Measurements and preferences';
      subtitleEl.style.display='none';
      backBtn.style.display='inline-flex';
      break;
    case 3:
      headerTitle.textContent='Bra Sizes';
      subtitleEl.style.display='none';
      backBtn.style.display='inline-flex';
      break;
    case 4:
      headerTitle.textContent='Product recommendation';
      backBtn.style.display='inline-flex';
      populateProductPreview();
      break;
    default:
      headerTitle.textContent='';
      subtitleEl.style.display='none';
  }
  backBtn.onclick = ()=>goToStep(currentStep-1);
}

// ------------------ VALIDATION ------------------
function showError(inputEl,msg){
  let container=inputEl.closest('.zsr-dropdown')||inputEl.closest('.zds-drop-down-menu')||inputEl.parentElement;
  if(!container) container=inputEl;
  container.querySelectorAll('.error-text').forEach(e=>e.remove());
  const error=document.createElement('div');
  error.className='error-text';
  error.textContent=msg;
  container.appendChild(error);
}

function validateStep(step){
  let valid=true;
  if(step===1){
    const fields=[
      {el:document.getElementById('zds-344'),msg:'Please select height'},
      {el:document.getElementById('zds-346'),msg:'Please select weight'},
      {el:document.getElementById('zds-348'),msg:'Please select age'}
    ];
    fields.forEach(f=>{if(!f.el?.dataset.value){showError(f.el,f.msg);valid=false;}});
  }
  if(step===2){
    const fields=[
      {el:document.getElementById('zds-430'),msg:'Please select waist'},
      {el:document.getElementById('zds-432'),msg:'Please select hip'}
    ];
    fields.forEach(f=>{if(!f.el?.dataset.value){showError(f.el,f.msg);valid=false;}});
    const fit=document.getElementById('zds-slider-thumb-4340');
    if(!fit || fit.value===undefined){showError(fit,'Please select fit preference');valid=false;}
  }
  return valid;
}

// Next / Prev
document.addEventListener('click', e=>{
  const nextBtn=e.target.closest('.zds-continue-btn,[data-next]');
  if(nextBtn && validateStep(currentStep)){
    const next = Number(nextBtn.dataset.next) || currentStep+1;
    goToStep(next);
  }
  const prevBtn=e.target.closest('[data-prev]');
  if(prevBtn){
    const prev=Number(prevBtn.dataset.prev) || currentStep-1;
    goToStep(prev);
  }
});

// ------------------ DATA COLLECTION (convert to base units) ------------------
function getCollectedData(){
  const heightBtn = document.getElementById('zds-344');
  const waistBtn = document.getElementById('zds-430');
  const hipBtn = document.getElementById('zds-432');
  const outlineBtn = document.getElementById('zds-outline');
  const weightBtn = document.getElementById('zds-346');

  // Raw values in current UI units
  const rawHeight = Number(heightBtn?.dataset.value) || 0;
  const rawWaist = Number(waistBtn?.dataset.value) || 0;
  const rawHip = Number(hipBtn?.dataset.value) || 0;
  const rawOutline = Number(outlineBtn?.dataset.value) || 0;
  const rawWeight = Number(weightBtn?.dataset.value) || 0;

  // Convert to base units for algorithm: inches for lengths, kg for weight
  const heightIn = unitState.height === 'cm' ? cmToInches(rawHeight) : rawHeight;
  const waistIn = unitState.waist === 'cm' ? cmToInches(rawWaist) : rawWaist;
  const hipIn = unitState.hip === 'cm' ? cmToInches(rawHip) : rawHip;
  const outlineIn = unitState.outline === 'cm' ? cmToInches(rawOutline) : rawOutline;
  const weightKg = unitState.weight === 'lbs' ? lbsToKg(rawWeight) : rawWeight;

  return {
    heightIn,
    weightKg,
    age: document.getElementById('zds-348')?.dataset.value,
    waistIn,
    hipIn,
    outlineIn,
    fitPreference: document.getElementById('zds-slider-thumb-4340')?.value,
    cup: document.getElementById('zds-cup-size')?.dataset.value,
    additionalInfo: document.getElementById('AdditionalInfo')?.value,

    // also expose UI values + units for display
    ui: {
      heightValue: rawHeight,
      heightUnit: unitState.height,
      waistValue: rawWaist,
      waistUnit: unitState.waist,
      hipValue: rawHip,
      hipUnit: unitState.hip,
      outlineValue: rawOutline,
      outlineUnit: unitState.outline,
      weightValue: rawWeight,
      weightUnit: unitState.weight
    }
  };
}

// ------------------ SIZE COMPUTATION (unchanged: uses inches/kg) ------------------
function computeRecommendedSize(data) {
  const waist = Math.round(data.waistIn);
  const hip = Math.round(data.hipIn);

  const chart = [
    { size: 'XXS', waist: [22, 24], hip: [30, 32] },
    { size: 'XS',  waist: [24, 26], hip: [32, 34] },
    { size: 'S',   waist: [26, 28], hip: [34, 36] },
    { size: 'M',   waist: [28, 32], hip: [36, 38] },
    { size: 'L',   waist: [32, 34], hip: [38, 40] },
    { size: 'XL',  waist: [34, 36], hip: [40, 42] },
    { size: 'XXL', waist: [36, 38], hip: [42, 44] },
  ];

  // 1️⃣ Try to find a size where BOTH waist & hip fall inside range
  let exact = chart.find(s =>
    waist >= s.waist[0] && waist <= s.waist[1] &&
    hip   >= s.hip[0]   && hip   <= s.hip[1]
  );
  if (exact) return exact.size;

  // 2️⃣ If not perfect match, pick the smallest size
  // that still FITS (size-up logic)
  for (let s of chart) {
    if (
      waist <= s.waist[1] &&
      hip   <= s.hip[1]
    ) {
      return s.size;
    }
  }

  // 3️⃣ If bigger than XXL → return largest available
  return "XXL";
}


// ------------------ PREVIEW (show in current units) ------------------
function populateProductPreview(){
  const data=getCollectedData();
  const recommended=computeRecommendedSize(data);
  document.getElementById('recommendedSize').textContent=recommended;

  const d = data.ui;
  const details=[];

  if(d.waistValue) details.push(`Waist: ${Math.round(d.waistValue)} ${d.waistUnit}`);
  if(d.hipValue)   details.push(`Hip: ${Math.round(d.hipValue)} ${d.hipUnit}`);
  if(data.cup)     details.push(`Cup: ${data.cup}`);

  if(d.heightValue) details.push(`Height: ${Math.round(d.heightValue)} ${d.heightUnit}`);
  if(d.weightValue) details.push(`Weight: ${Math.round(d.weightValue)} ${d.weightUnit}`);

  document.getElementById('recommendationDetails').textContent =
    details.length ? details.join(' • ') : 'Based on your measurements';
}

// ------------------ CLOSE DRAWER ------------------
document.getElementById("zdsCloseBtn")?.addEventListener("click", ()=>{
  drawerRoot.classList.remove("open");
  drawerRoot.setAttribute("aria-hidden","true");
  closeAllDropdowns();
});

document.getElementById('screen4End')?.addEventListener('click', () => {
  const data = getCollectedData();
  const recommendedSize = computeRecommendedSize(data);
  console.log('Collected Data:', data);
  console.log('Recommended Size:', recommendedSize);

  drawerRoot.classList.remove('open');
  drawerRoot.setAttribute('aria-hidden', 'true');
});
